import { render, staticRenderFns } from "./LeftSuperAdmin.vue?vue&type=template&id=68356388&"
import script from "./LeftSuperAdmin.vue?vue&type=script&lang=js&"
export * from "./LeftSuperAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports